export default "__VITE_ASSET__DGgXyqSy__"